"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paddingForClosedDrawer = exports.paddingForDrawer = exports.drawerTop = exports.listItem = exports.listItemOpen = exports.useStyles = void 0;
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var core_1 = require("@material-ui/core");
var theme_1 = require("../../theme");
var drawerWidth = 240;
exports.useStyles = makeStyles_1.default(function (theme) {
    return core_1.createStyles({
        paper: {
            backgroundColor: theme.mixins.themeStyle.appBarColor,
            color: theme_1.contrast().primary,
            borderRight: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: 76,
        },
        drawerButton: {
            padding: '0 !important',
            marginTop: 10,
            // without important, would be overridden…
            backgroundColor: 'transparent !important',
        },
        profileButton: {
            padding: 0,
            marginTop: 16,
            position: 'absolute',
            right: 20,
        },
        drawerText: {
            marginLeft: 3,
            color: theme_1.contrast().primary,
        },
        drawerTextSelected: {
            marginLeft: 3,
            color: theme.palette.secondary.main,
        },
        selected: {
            '&.Mui-selected': {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.secondary.main,
                '&:hover, &:focus': {
                    backgroundColor: theme.palette.grey[100],
                },
            },
        },
    });
});
var listItemCommon = {
    height: 50,
    margin: 10,
    borderRadius: 6,
    transition: '0.3s',
};
exports.listItemOpen = __assign(__assign({}, listItemCommon), { width: 220 });
exports.listItem = __assign(__assign({}, listItemCommon), { width: 60 });
exports.drawerTop = {
    paddingTop: 20,
};
exports.paddingForDrawer = {
    paddingLeft: 240,
    transition: '0.3s',
};
exports.paddingForClosedDrawer = {
    paddingLeft: 74,
    transition: '0.3s',
};
//# sourceMappingURL=NavigationDrawerStyles.js.map